// extracted by mini-css-extract-plugin
export default {"othersWrap":"others_othersWrap__KuUcq"};